import React from 'react';

export default class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {bottom: false}
  }
  handleScroll = (e) => {
    this.setState({bottom: e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight})
  }

  render() {
    return (
      <div id="layout-about-container">
        <div className="mdl-mini-footer" onClick={this.props.toggleAbout}>
          <div className="mdl-mini-footer__left-section ">
            <span className=" mdl-logo mdl-layout-title">
              Flood Risk: A Planet + Cloud to Street Demonstration
            </span>
          </div>
          <div className="mdl-mini-footer__right-section">
            <span>
              <img src={process.env.PUBLIC_URL + "/images/planet_white.png"} alt="Planet" height="50" />
              <img
                src={process.env.PUBLIC_URL + "/images/cloud2street_white.png"}
                alt="Cloud2Street"
                height="50"
              />
              <img
                src={process.env.PUBLIC_URL + "/images/rockefeller_white.png"}
                alt="The Rockefeller Foundation"
                height="50"
              />
            </span>
            <button
              id="more-button"
              style={{marginLeft: '20px'}}
              className="mdl-button mdl-js-button mdl-button--icon"
            >
              <i className="material-icons">more_vert</i>
            </button>
          </div>
        </div>
        <div className="layout-about-body ">
          <div className="layout-about-body-content mdl-grid">
            <div className="layout-about-body-text mdl-cell mdl-cell--12-col" onScroll={this.handleScroll}>
              <h3>Illuminating and Financing Climate Risk</h3>
              <h4>A Planet and Cloud to Street Demonstration</h4>
              <span>
                <p />
                Large-scale action on climate change and sustainable development has never been more urgently needed.{' '}
                Despite scientific consensus on the need to shift to a low-carbon economy, and the very limited time{' '}
                we have to accomplish it, in many domains we still lack practical, cost-effective ways to measure{' '}
                climate and sustainability risks, and therefore ways to effectively allocate capital towards solutions.
                <p />
                There is plenty of long-term, institutional capital available in private financial markets to meet the{' '}
                climate finance challenge – over{' '}
                <a href="http://www.oecd.org/mcm/C-MIN(2014)19-ENG.pdf" target="_blank" rel="noopener noreferrer">$83 trillion</a>{' '}
                in the OECD countries alone. Putting some portion of this capital to work is critical not only to{' '}
                mitigate financial risks from climate impacts, but to stimulate investments in a climate resilient future. 
                <p />
                Today, however, virtually all of this capital remains underinvested in these challenges. Most{' '}
                financial instruments and investment vehicles do not properly account for the material correlations{' '}
                between climate risks and economic assets. This mispricing has resulted in the accumulation of{' '}
                ‘invisible’ climate risks in the financial system, as well as a shortage of capital for sustainable{' '}
                solutions. 
                <p />
                Practically speaking, it also means exposure to many forms of risk are increasing, particularly those{' '}
                at the intersection of climate change and the{' '}
                “<a href="http://chubasco.niu.edu/ebe.htm" target="_blank" rel="noopener noreferrer">expanding bullseye</a>”
                of human-development. As more people live and work in more climate-vulnerable places, the frequency,{' '}
                severity and impact of floods, typhoons, droughts, fires and other disasters is increasing significantly. 
                <p />
                These risks have historically been hard to measure and thus difficult to “price in” to everyday{' '}
                economic and policy decisions—now, climate change makes it urgently necessary to do so. Currently,{' '}
                only 7% of economic losses from disasters are met by humanitarian relief. With floods doubling{' '}
                worldwide due to climate change and population migration, it is simply unrealistic to meet the need{' '}
                without private capital. However today only 1-3% of economic loss from disasters are insured.
                <p />
                This is especially true in poor and vulnerable communities, which often lack the technical{' '}
                infrastructure to measure such risks effectively. Without signals to respond to, and corresponding{' '}
                incentives built upon them, people continue to build in flood prone areas, suppress fires in the{' '}
                name of development, destroy coral reefs that provide coastal protection, and otherwise make decisions{' '}
                that increase their exposure to various hazards. 
                <p />
                Fortunately, new technologies – particularly low-cost remote-sensing technologies such as satellites{' '}
                and drones, cloud computing and artificial intelligence – now enable us to model, measure and monitor{' '}
                some of these environmental, social and climate risks with unprecedented detail, in near real-time.  
                <p />
                We call these measures{' '}
                “<a href="https://ssir.org/articles/entry/after_big_data_the_coming_age_of_big_indicators" target="_blank" rel="noopener noreferrer">Big Indicators</a>”{' '}
                 – high resolution, globally complete, spatially explicit, and dynamically-updated indicators of risk{' '}
                that can help communities set effective mitigation, adaptation and resilience policies and respond{' '}
                more effectively to climate-related disasters when they strike.{' '}
                Just as importantly, these indicators can power a new generation of financial instruments - novel{' '}
                insurance, debt and pay-for-performance investment vehicles that can help communities finance climate{' '}
                risk in new ways and reduce its impacts.
                <p />
                In the following demonstration, funded by the Rockefeller Foundation, and developed with our{' '}
                colleagues at <a href="https://www.cloudtostreet.info/" target="_blank" rel="noopener noreferrer">Cloud to Street</a>
                , we illustrate how these kinds of indicators can illuminate risk in new ways. We specifically analyze{' '}
                flood risk in three communities: Beira, Mozambique, Colombo, Sri Lanka and Nagapattinam, India.
                <p />
                We begin by producing a high-resolution satellite basemap of each community, based on Planet imagery.{' '}
                Then, using the tools of machine learning, we automatically extract building footprints from the{' '}
                imagery, showing us where all of human settlement has occurred. Finally, we then overlay{' '}
                Cloud to Street’s high-resolution assessment of historical flood frequency (also derived from{' '}
                historical satellite imagery). Analyzing the full satellite repository for each pixel in the area{' '}
                across several satellites reveals changing local flood patterns and flood exposure. The resulting{' '}
                picture shows, in fine detail, where communities are building in places that are especially{' '}
                susceptible to flooding, especially in a climate-changing world. 
                <p />
                Using Planet’s continuous satellite monitoring, this kind of risk assessment can be continuously{' '}
                produced on a daily, weekly or monthly basis, illustrating how many buildings are in flood-prone{' '}
                areas, and how climate-related flood risks are evolving in real-time. And that’s exactly the kind of{' '}
                indicator one might use to power a new kind of microinsurance product, climate-resilience municipal{' '}
                bond or other new kind of financial instrument. As the indicator moves, so might the premium paid, or{' '}
                the payout in the case of a disaster. Moreover, the technology that developed these maps is based on{' '}
                historical data, but can also produce data in near real-time, with such resolution and consistency{' '}
                that it could support triggered insurance payouts.  
                <p />
                In all cases, the very same tool that allows us to illuminate risk before a flooding event also allows{' '}
                us to more accurately measure actual exposure to an event after its occurred, allowing for faster and{' '}
                more effective response, which itself is a form of adaptation.
                <p />
                In principle, using these approaches, these kind of indicators can now be produced for any community{' '}
                in the world, including those that have not benefited from such assessments in the past. Moreover,{' '}
                while this demonstration illustrates flood risk specifically, this approach can be extended to cover{' '}
                other climate-related risks – in areas such as agriculture, fire and migration, among others.
                <p />
                For example, in March of 2019 Cyclone Idai killed thousands of people in Mozambique.  A cyclone of a{' '}
                similar size and intensity hit the country twenty years earlier, killing almost the same number of{' '}
                people and levelling a similar amount of damage. Even after two decades of development efforts,{' '}
                scientific advancements, and climate finance commitments, the country was apparently no more resilient{' '}
                to disaster.  
                <p />
                The month prior to the disaster, the UN country office in Mozambique began exploring with the national{' '}
                government the potential of satellite data to inform flood risk across the country. In early March,{' '}
                before the cyclone and and satellite-based flood analysis began, officials told Cloud to Street{' '}
                suspected flooding was already starting in rural parts of the country, but they needed to send someone{' '}
                on foot to check. The cyclone struck before officials were able to make a report.
                <p />
                Could access to dynamic risk information ahead of the disaster have helped Mozambique prepare for{' '}
                this disaster that was so similar?  Could it have enabled new climate finance mechanisms, like {' '}
                parametric insurance, that would support the UN and the local government? Are there interventions that{' '}
                we can put in place today to strengthen local capacity and their coordination before the next disaster hits?{' '}
                <hr/>
                We believe so - just as we believe that the future financial system must incorporate and respond to{' '}
                climate signals generally. 
                <p />
                We invite you to view the demonstration of flood risk, and would like to thank the Rockefeller{' '}
                Foundation for its continued support of our work in this area.
              </span>
              
            </div>
            <div className="layout-about-body-button" style={{textAlign: 'center'}}>
                {!this.state.bottom && (<div className="layout-about-body-fade" />)}
                <hr />
                <button
                  className={"mdl-button mdl-js-button" 
                  + (this.state.bottom ? "  mdl-button--raised mdl-button--accent" : "")}
                  onClick={this.props.toggleAbout}
                >
                  View Demonstration
                </button>
              </div>
          </div>
        </div>
      </div>
    );
  }
}
